import React, {Component} from 'react';
import DefaultModal from "../invoice/DefaultModal";
import {deepCopyObject, isSularSaglikHizmetleri, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import Alert from 'react-s-alert';
import '../../local_node_modules/react-select/dist/react-select.css';
import 'react-datetime/css/react-datetime.css';
import 'moment/locale/tr';
import NumberFormat from "react-number-format";
import {Decimal} from "decimal.js";
import ReactLoading from "react-loading";
import {filterOptions} from "../../helper/invoiceHelper";
import Select from "../../local_node_modules/react-select";
import {UncontrolledTooltip} from "reactstrap";
import {isValidInboxLine} from "../../common/componentValidation";
import ReactLoadingTop from "../../components/ReactLoadingTop";
import {wsSend} from "./erpHelper";
import ERPStockModalWs from "./ERPStockModalWs";

class ERPLineModalWs extends Component {

	constructor(props) {
		super(props);
		this.state ={
			selectedList:[],
			inboxLineList:[],
			stockCodeList:[],
			stockNameList:[],
			stockList:[],
			error:{},
			loadingHtml:false
		};
		this.confirm     	= this.confirm.bind(this);
		this.onChange    	= this.onChange.bind(this);
		this.onStockChange  = this.onStockChange.bind(this);
		this.validateMessage= this.validateMessage.bind(this);
		this.validateClass  = this.validateClass.bind(this);
		this.setStock  		= this.setStock.bind(this);
		this.downloadMedia  = this.downloadMedia.bind(this);
	}

	componentDidMount () {
		let self = this;
		self.getConnectionInfo();
		self.downloadMedia(self.props.documentUuid,self.props.year,self.props.month);

		let params = {
			url: `/connector/getStockList`,
			method: "post",
			data:{
				recordIdList:self.props.recordIdList,
				year: this.props.year
			}
		};
		self.setState({loading:true});
		request(params)
			.then(function (response) {
				let {stockList} = response.data;
				let {inboxLineList} = self.props;
				let stockCodeList=[];
				let stockNameList=[];
				for(let i=0;i<stockList.length;i++){
					if(stockList[i].itemCode)
						stockCodeList[stockList[i].itemCode] = stockList[i];

					if(stockList[i].edmItemName)
						stockNameList[stockList[i].edmItemName] = stockList[i];
				}
				if(isSularSaglikHizmetleri(self.props.currentUser.vknTckn)){
					for (let j = 0; j < inboxLineList.length; j++) {
						inboxLineList[j].itemCode = '011';
						inboxLineList[j].itemName = 'HASTANE MUAYENE';
						inboxLineList[j].itemUnit = 'ADET';
						inboxLineList[j].stockReferenceId = '1a9cac31-96d8-e911-80ba-0a94ef447bb9';
						inboxLineList[j].lineType = 'Malzeme';
						inboxLineList[j].success = true;
					}
				}else {
					for (let j = 0; j < inboxLineList.length; j++) {
						let flag = true;
						if (inboxLineList[j].edmItemName) {
							if (stockNameList[inboxLineList[j].edmItemName]) {
								inboxLineList[j].itemCode = stockNameList[inboxLineList[j].edmItemName].itemCode;
								inboxLineList[j].itemName = stockNameList[inboxLineList[j].edmItemName].itemName;
								inboxLineList[j].itemUnit = stockNameList[inboxLineList[j].edmItemName].itemUnit;
								inboxLineList[j].stockReferenceId = stockNameList[inboxLineList[j].edmItemName].referenceId;
								inboxLineList[j].lineType = stockNameList[inboxLineList[j].edmItemName].lineType;
								inboxLineList[j].success = true;
								flag = false;
							}
						}
						if (flag) {
							if (inboxLineList[j].itemCode) {
								if (stockCodeList[inboxLineList[j].itemCode]) {
									inboxLineList[j].itemName = stockCodeList[inboxLineList[j].itemCode].itemName;
									inboxLineList[j].itemUnit = stockCodeList[inboxLineList[j].itemCode].itemUnit;
									inboxLineList[j].stockReferenceId = stockCodeList[inboxLineList[j].itemCode].referenceId;
									inboxLineList[j].edmItemName = stockCodeList[inboxLineList[j].itemCode].edmItemName;
									inboxLineList[j].lineType = stockCodeList[inboxLineList[j].itemCode].lineType;
									inboxLineList[j].success = true;
									flag = false;
								}
							}
						}
					}
				}
				self.setState({stockCodeList, stockNameList,inboxLineList,loading:false});
			}).catch(function (error) {
			showAxiosError(error);
			self.props.toggleModal(false,false);
		});
	}
	getConnectionInfo = async()=>{
		let self = this;
		let params = {
			url: `/connector/getConnectionInfo`,
			method: "post"
		};
		try{
			let {data} = await request(params);
			if(data!=null){
				let connection = "Data Source="+data.dataSource+";Initial Catalog="+data.initialCatalog+";User ID="+data.dbUser+";Password="+data.dbPassword+";"
				self.setState({connectionInfo:data,connection});
				self.listenWebSocket(data.ownerIp);
			}
		}catch(error){
			let err = {response:{data:"Konnektör Bulunamadı"}}
			showAxiosError(err);
		}
	}
	readStock = (key) =>{
		let self = this;
		if (key.length > 0) {
			let params = {
				url: `/connector/readStock`,
				method: "post",
				data: key
			};
			request(params)
				.then(response => {
					let data = response.data;
					if ('stocks' in data){
						let stocks = data.stocks;
						let options = stocks.map(stock => ({
							value: stock.itemName,
							label: stock.itemName,
							stock: stock
						}));
						self.setState({stockOptions:options})
					}else if('stockListSql' in data){
						const {connectionInfo,ws} = this.state;
						wsSend(connectionInfo,ws,data.stockListSql,"READ_STOCK")
					}

				})
				.catch(function (error) {
					showAxiosError(error);
				});
		} else {
			return Promise.resolve({options: []});
		}
	}
	readPartyLot = (searchKey,index) =>{
		let self = this;
		let stockReferenceId =  this.state.inboxLineList[index].stockReferenceId;
		if (searchKey.length > 0) {
			let params = {
				url: `/connector/readPartyLot`,
				method: "post",
				data: {searchKey,stockReferenceId}
			};
			request(params)
				.then(response => {
					let data = response.data;
					if(data!=null){
						const {connectionInfo,ws} = this.state;
						wsSend(connectionInfo,ws,data,"READ_PARTY_LOT")
					}
				})
				.catch(function (error) {
					showAxiosError(error);
				});
		}
	}


	listenWebSocket = (ip) =>{
		let self = this;
		ip= ip + "/websocket/chat";
		const ws = new WebSocket(ip);
		this.setState({ws});

		ws.onopen = () => {
			console.log('connected');
			this.setState({connected:true});
		}

		// listen to data sent from the websocket server
		ws.onmessage = evt => {
			let {queryType,rows,uuid} = JSON.parse(evt.data)
			rows = JSON.parse(rows);
			console.log("gelen veri",rows)

			if(queryType == "READ_STOCK" && rows != null){
				let stockOptions = rows.map(stock => ({
					value: stock.itemName,
					label: stock.itemName,
					stock: {...stock,stockType:"connector"}
				}));
				stockOptions.push({
					value:-1,
					label:"ERP Stok Listesine Ekle"
				})
				self.setState({stockOptions})
			}else if(queryType == "WRITE_STOCK" && rows != null){
				self.setStock(rows[0]);
			}else if(queryType == "READ_PARTY_LOT" && rows != null){
				let partyLotOptions = rows.map(row => ({
					value: (row.partyCode ? row.partyCode : "") +"-"+ (row.lotCode ? row.lotCode : ""),
					label: (row.partyCode ? row.partyCode : "") +"-"+ (row.lotCode ? row.lotCode : ""),
					partyCode:row.partyCode,
					lotCode:row.lotCode,
					partyLotCodeReferenceId:row.referenceId
				}));
				self.setState({partyLotOptions})
			}
		}

		ws.onclose = () => {
			console.log('disconnected')
			this.setState({connected:false});
		}
	}
	onChange(e,index){
		let inboxLineList = deepCopyObject(this.state.inboxLineList);
		inboxLineList[index][e.name]=
			((e.name === "invoiceQuantity" && e.value !== "" ) ||
				(e.name === "unitPrice"  && e.value !== "") ||
				(e.name === "allowancePercent"  && e.value !== "") ||
				(e.name === "allowanceAmount"  && e.value !== "") ||
				(e.name === "kdvPercent"  && e.value !== "") ||
				(e.name === "kdvAmount"  && e.value !== "") ||
				(e.name === "lineExtensionAmount"  && e.value !== "")) ? (new Decimal(e.value)).toNumber() : e.value;
		this.setState({inboxLineList});
	}

	confirm(){
		let self= this;
		let {inboxLineList} = self.state;
		let result = isValidInboxLine(inboxLineList);
		let valid = result.valid;
		if (valid) {
			this.props.listener(inboxLineList);
		}else{
			self.setState({error:result.error,btnDisabled:false});
			Alert.error(result.errorMessage, {
				position: 'bottom-right',
				effect: 'stackslide',
				timeout: 3000
			});
		}
	}

	arrowRenderer(e) {
		let onMouseDown = e.onMouseDown;
		return React.createElement('span', {
			className: 'search',
			onMouseDown: onMouseDown
		});
	}

	createStock = (option,  index) => {
		let {itemCode,itemName,itemUnit,edmItemName} = this.state.inboxLineList[index];
		let stock = {
			itemCode,
			itemName,
			itemUnit,
			edmItemName
		};
		this.setState({stock, stockModal: true, index});
	}

	onStockChange(data,  index) {
		let self= this;
		if(data.value==-1){
			this.createStock("", index)
		}
		if (data.hasOwnProperty("stock")) {
			let inboxLineList = deepCopyObject(this.state.inboxLineList);
			let stock = data.stock;
			inboxLineList[index].itemName=stock.itemName;
			inboxLineList[index].itemCode=stock.itemCode;
			inboxLineList[index].itemUnit=stock.itemUnit;
			inboxLineList[index].stockReferenceId=stock.referenceId;
			inboxLineList[index].lineType=stock.lineType;
			inboxLineList[index].success=true;
			if(stock.stockType==="connector"){
				stock.edmItemName = inboxLineList[index].edmItemName;
				let data = deepCopyObject(stock);
				let params = {
					url:`/connector/writeStock`,
					method:"post",
					data:data
				};
				request(params)
					.then(response => {
						self.setState({inboxLineList});
					})
					.catch(function (error) {
						self.setState({saveLoading:false});
						showAxiosError(error);
					});
			}else{
				this.setState({inboxLineList});
			}
		}
	}
	onPartyLotChange(data,index) {
		let {inboxLineList} = this.state;
		inboxLineList[index].partyCode=data.partyCode;
		inboxLineList[index].lotCode=data.lotCode;
		inboxLineList[index].partyLotCodeReferenceId=data.partyLotCodeReferenceId;
		this.setState({inboxLineList});
	}
	validateClass(id) {
		let {error} = this.state;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let {error} = this.state;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	setStock(stock) {
		let {index,inboxLineList} = this.state;
		inboxLineList[index].itemName=stock.itemName;
		inboxLineList[index].itemCode=stock.itemCode;
		inboxLineList[index].itemUnit=stock.itemUnit;
		inboxLineList[index].stockReferenceId=stock.referenceId;
		inboxLineList[index].lineType=stock.lineType;
		inboxLineList[index].success=true;
		this.setState({inboxLineList,stockModal:false});
	}

	downloadMedia(documentUuid,year,month) {
		let self = this;
		let documentType = this.props.documentType ? this.props.documentType : "invoice";
		let params;

		if(documentType === 'despatch'){
			params = {
				url: `/despatchInbox/downloadMedia/html`,
				responseType: 'arraybuffer',
				method: "post",
				data:documentUuid
			};
		}else if (documentType === 'invoiceOutbox') {
			params = {
				url: `/outbox/downloadMedia/html`,
				responseType: 'arraybuffer',
				method: "post",
				data: {
					documentUuid,
					year,
					month
				}
			}
		} else if (documentType === 'earchiveInvoice') {
			params = {
				url: `/eArchive/downloadMedia/html`,
				responseType: 'arraybuffer',
				method: "post",
				data: {
					documentUuid,
					year,
					month
				}
			}
		} else {
			params = {
				url: `/inbox/downloadMedia/html`,
				responseType: 'arraybuffer',
				method: "post",
				data: {
					documentUuid,
					year,
					month
				}
			}
		}
		self.setState({loadingHtml:true});
		request(params)
			.then(function (response) {
				let blob = new Blob([response.data], {type: response.headers["content-type"]});
				let urlCreator = window.URL || window.webkitURL;
				let url = urlCreator.createObjectURL(blob);
				self.setState({url,loadingHtml:false});
			}).catch(function (error) {
			if (error.response === undefined) {
				showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
			} else {
				let enc = new TextDecoder("utf-8");
				showAxiosError({message: enc.decode(error.response.data)});
			}
			self.setState({mediaModal: false, title: null,loadingHtml:false});
		});
	}
	uuidGenerator = ()=> {
		return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
			(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
		);
	}
	partyLotCheck = (e)=> {
		let partyLotChecked = e.target.checked;
		this.setState({partyLotChecked})
	}
	render() {
		return (
			<DefaultModal disabled={this.state.loading || this.state.btnDisabled || (this.state.inboxLineList && this.state.inboxLineList.length ===0)}
						  isOpen={this.props.modal}
						  size="xxl"
						  title={this.props.title || ""}
						  confirmBtnText="Kaydet"
						  cancelBtnText="Kapat"
						  onConfirm={this.confirm}
						  onCancel={()=>this.props.toggleModal(false)}>
				<div className="row">
					<div className="row col-sm-12" style={{marginLeft: '10px', paddingLeft: "5px"}}>
						{!this.state.loading &&
							<p className="text-success" style={{margin: '0px', padding: "0px"}}>* ERP'deki stok bilgisi ile eşleşti.&nbsp;&nbsp;</p>
						}
					</div>
					<div className="row col-sm-12" style={{marginLeft: '10px', paddingLeft: "5px" ,display:"flex",alignItems:"center"}}>
						<span style={{marginRight:'10px'}}>Party Lot</span>
						<input type="checkbox" checked={this.state.partyLotChecked} onChange={(e) => this.partyLotCheck(e)}/>
					</div>
					<div className="row col-sm-12" style={{paddingBottom: '10px'}}>
						<table className="" style={{textAlign: 'center', paddingBottom:'2px'}}>
							<thead>
							<tr style={{backgroundColor: '#ebedf0'}}>
								<th width="3%">#</th>
								<th width="7%">Kod</th>
								<th width="14%">Ürün/Hizmet Adı</th>
								<th width="14%">ERP Ürün Adı</th>
								{this.state.partyLotChecked && <th width="10%">Parti/Lot</th>}
								<th width="7%">Miktar</th>
								<th width="4%">Birim</th>
								<th width="6%">Birim Fiyat</th>
								<th width="6%">İsk. Oranı</th>
								<th width="6%">İsk. Tutarı</th>
								<th width="4%">Kdv Oranı</th>
								<th width="7%">Kdv Tutarı</th>
								<th width="3%">Para Birimi</th>
								<th width="7%">Satır Tutarı</th>
							</tr>
							</thead>
							<tbody>
							{this.state.loading ?
								<tr>
									<td colSpan={15}>
										<ReactLoading type="spinningBubbles" style={{
											width: "70px",
											height: "70px",
											margin: "20px auto 0 auto",
											fill: "#888"
										}}/></td>
								</tr>
								:
								this.state.inboxLineList.map((inboxLine, index) =>
									<tr key={index+'_inboxLine'} style={{backgroundColor:(inboxLine.success ? 'lightgreen' : '')}}>
										<td style={{margin:"0px"}}>{(index+1)}</td>
										<td className={"form-group" + this.validateClass('itemCode_'+ index)}>
											<input
												id={'itemCode_' + index}
												type="text"
												maxLength={255}
												className="form-control"
												value={inboxLine.itemCode}
												onChange={(e) => this.onChange({
													value: e.target.value,
													name: "itemCode"
												}, index)}/>
											{this.validateMessage('itemCode_' + index) !== "" &&
												<UncontrolledTooltip placement="right"
																	 target={'itemCode_' + index}
																	 delay={0}>
													{this.validateMessage('itemCode_' + index)}
												</UncontrolledTooltip>}
										</td>
										<td className={"form-group" + this.validateClass('edmItemName_'+ index)}>
											<input
												id={'edmItemName_' + index}
												type="text"
												data-vlength="1,255"
												maxLength={255}
												className="form-control"
												value={inboxLine.edmItemName}
												onChange={(e) => this.onChange({
													value: e.target.value,
													name: "edmItemName"
												}, index)}/>
											{this.validateMessage('edmItemName_' + index) !== "" &&
												<UncontrolledTooltip placement="right"
																	 target={'edmItemName_' + index}
																	 delay={0}>
													{this.validateMessage('edmItemName_' + index)}
												</UncontrolledTooltip>}
										</td>
										<td className={"form-group" + this.validateClass('itemName_'+ index)}>
											{this.state.manual &&
												<input
													id={'itemName_' + index}
													type="text"
													disabled={inboxLine.success}
													data-vlength="1,255"
													maxLength={255}
													className="form-control"
													value={inboxLine.itemName}
													onChange={(e) => this.onChange({
														value: e.target.value,
														name: "itemName"
													}, index)}/>
											}
											{!this.state.manual &&
												<Select.Creatable
													clearable={false}
													multi={false}
													wrapperStyle={{position: 'relative'}}
													className="select-control"
													ignoreAccents={false}
													id={'itemName_' + index}
													value={{
														value: inboxLine.itemName,
														label: inboxLine.itemName
													}}
													onChange={(e) => e && this.onStockChange(e, index)}
													onInputChange={(key) => this.readStock(key)}
													isLoading={this.state.cariLoading}
													autoload={false}
													disabled={isSularSaglikHizmetleri(this.props.currentUser.vknTckn)}
													cache={false}
													noResultsText="Kayıt bulunamadı."
													searchPromptText="Arama için en az 1 karakter giriniz."
													placeholder="Ürün Adı veya Kodu ile arama yapabilirsiniz"
													loadingPlaceholder="Yükleniyor..."
													filterOptions={(options, filter, currentValues) => filterOptions(options, filter, currentValues)}
													onNewOptionClick={(option) => this.createStock(option, index)}
													promptTextCreator={(label) => "ERP Stoğuna Ekle"}
													showNewOptionAtTop={false}
													arrowRenderer={this.arrowRenderer}
													onCloseResetsInput={false}
													onSelectResetsInput={false}
													onBlurResetsInput={false}
													options={this.state.stockOptions}
													// loadOptions={(key) => this.readStock(key) }
												/>}
										</td>
										{this.state.partyLotChecked && <td className={"form-group" + this.validateClass('itemName_'+ index)}>
											<Select.Creatable
												clearable={false}
												multi={false}
												wrapperStyle={{position: 'relative'}}
												className="select-control"
												ignoreAccents={false}
												id={'itemName_' + index}
												value={{
													value: inboxLine.partyCode ? inboxLine.partyCode : "" + "-" + inboxLine.lotCode ? inboxLine.lotCode :"",
													label: inboxLine.partyCode ? inboxLine.partyCode : "" + "-" + inboxLine.lotCode ? inboxLine.lotCode :"",
													partyCode:inboxLine.partyCode,
													lotCode:inboxLine.lotCode
												}}
												onChange={(e) => e && this.onPartyLotChange(e, index)}
												onInputChange={(key) => this.readPartyLot(key,index)}
												isLoading={this.state.cariLoading}
												autoload={false}
												cache={false}
												noResultsText="Kayıt bulunamadı."
												searchPromptText="Arama için en az 1 karakter giriniz."
												placeholder="Ürün Adı veya Kodu ile arama yapabilirsiniz"
												loadingPlaceholder="Yükleniyor..."
												filterOptions={(options, filter, currentValues) => filterOptions(options, filter, currentValues)}
												onNewOptionClick={(option) => this.createPartyLot(option, index)}
												showNewOptionAtTop={false}
												arrowRenderer={this.arrowRenderer}
												onCloseResetsInput={false}
												onSelectResetsInput={false}
												onBlurResetsInput={false}
												options={this.state.partyLotOptions}
												disabled={inboxLine.stockReferenceId==null ? true : false}
												// loadOptions={(key) => this.readStock(key) }
											/>
										</td>}
										<td>
											<NumberFormat id={'invoiceQuantity_' + index}
														  value={inboxLine.invoiceQuantity}
														  allowNegative={false}
														  isNumericString={true}
														  allowEmptyFormatting={false}
														  decimalScale={9}
														  thousandSeparator={'.'}
														  decimalSeparator={','}
														  displayType="input"
														  placeholder="Miktar giriniz"
														  renderText={value => {
															  value.replace(/\./g, ',')
														  }}
														  onValueChange={(e) => this.onChange({
															  value: e.value,
															  name: "invoiceQuantity"
														  }, index)}
														  className="form-control"/>
										</td>
										<td className={"form-group" + this.validateClass('itemUnit_'+ index)}>
											<input
												id={'itemUnit_' + index}
												type="text"
												maxLength={255}
												className="form-control"
												value={inboxLine.itemUnit}
												onChange={(e) => this.onChange({
													value: e.target.value,
													name: "itemUnit"
												}, index)}/>
											{this.validateMessage('itemUnit_' + index) !== "" &&
												<UncontrolledTooltip placement="right"
																	 target={'itemUnit_' + index}
																	 delay={0}>
													{this.validateMessage('itemUnit_' + index)}
												</UncontrolledTooltip>}
										</td>
										<td>
											<NumberFormat id={'unitPrice_' + index}
														  value={inboxLine.unitPrice}
														  allowNegative={false}
														  isNumericString={true}
														  allowEmptyFormatting={false}
														  decimalScale={9}
														  thousandSeparator={'.'}
														  decimalSeparator={','}
														  displayType="input"
														  placeholder="Birim Fiyat giriniz"
														  renderText={value => {
															  value.replace(/\./g, ',')
														  }}
														  onValueChange={(e) => this.onChange({
															  value: e.value,
															  name: "unitPrice"
														  }, index)}
														  className="form-control"/>
										</td>
										<td>
											<NumberFormat id={'allowancePercent_' + index}
														  value={inboxLine.allowancePercent}
														  allowNegative={false}
														  isNumericString={true}
														  allowEmptyFormatting={false}
														  decimalScale={9}
														  thousandSeparator={'.'}
														  decimalSeparator={','}
														  displayType="input"
														  placeholder="İskonto Oranı giriniz"
														  renderText={value => {
															  value.replace(/\./g, ',')
														  }}
														  onValueChange={(e) => this.onChange({
															  value: e.value,
															  name: "allowancePercent"
														  }, index)}
														  className="form-control"/>
										</td>
										<td>
											<NumberFormat id={'allowanceAmount_' + index}
														  value={inboxLine.allowanceAmount}
														  allowNegative={false}
														  isNumericString={true}
														  allowEmptyFormatting={false}
														  decimalScale={9}
														  thousandSeparator={'.'}
														  decimalSeparator={','}
														  displayType="input"
														  placeholder="İskonto Tutarı giriniz"
														  renderText={value => {
															  value.replace(/\./g, ',')
														  }}
														  onValueChange={(e) => this.onChange({
															  value: e.value,
															  name: "allowanceAmount"
														  }, index)}
														  className="form-control"/>
										</td>
										<td>
											<NumberFormat id={'kdvPercent_' + index}
														  value={inboxLine.kdvPercent}
														  allowNegative={false}
														  isNumericString={true}
														  allowEmptyFormatting={false}
														  decimalScale={9}
														  thousandSeparator={'.'}
														  decimalSeparator={','}
														  displayType="input"
														  placeholder="KDV Oranı giriniz"
														  renderText={value => {
															  value.replace(/\./g, ',')
														  }}
														  onValueChange={(e) => this.onChange({
															  value: e.value,
															  name: "kdvPercent"
														  }, index)}
														  className="form-control"/>
										</td>
										<td>
											<NumberFormat id={'kdvAmount_' + index}
														  value={inboxLine.kdvAmount}
														  allowNegative={false}
														  isNumericString={true}
														  allowEmptyFormatting={false}
														  decimalScale={9}
														  thousandSeparator={'.'}
														  decimalSeparator={','}
														  displayType="input"
														  placeholder="KDV Oranı giriniz"
														  renderText={value => {
															  value.replace(/\./g, ',')
														  }}
														  onValueChange={(e) => this.onChange({
															  value: e.value,
															  name: "kdvAmount"
														  }, index)}
														  className="form-control"/>
										</td>
										<td className={"form-group" + this.validateClass('currencyID_'+ index)}>
											<input
												id={'currencyID_' + index}
												type="text"
												data-vlength="1,255"
												maxLength={255}
												className="form-control"
												value={inboxLine.currencyID}
												onChange={(e) => this.onChange({
													value: e.target.value,
													name: "currencyID"
												}, index)}/>
											{this.validateMessage('currencyID_' + index) !== "" &&
												<UncontrolledTooltip placement="right"
																	 target={'currencyID_' + index}
																	 delay={0}>
													{this.validateMessage('currencyID_' + index)}
												</UncontrolledTooltip>}
										</td>
										<td>
											<NumberFormat id={'lineExtensionAmount_' + index}
														  value={inboxLine.lineExtensionAmount}
														  allowNegative={false}
														  isNumericString={true}
														  allowEmptyFormatting={false}
														  decimalScale={9}
														  thousandSeparator={'.'}
														  decimalSeparator={','}
														  displayType="input"
														  placeholder="Satır Tutarı giriniz"
														  renderText={value => {
															  value.replace(/\./g, ',')
														  }}
														  onValueChange={(e) => this.onChange({
															  value: e.value,
															  name: "lineExtensionAmount"
														  }, index)}
														  className="form-control"/>
										</td>
									</tr>
								)
							}
							</tbody>
						</table>
					</div>
					<div className="row col-sm-12">
						<div className="col-sm-2"/>
						<div className="col-sm-8" style={{marginTop: "20px", marginBottom: "2px", top: 0, left: 0, minHeight:'90px'}}>
							{(this.state.url && !this.state.loadingHtml) &&
								<iframe src={this.state.url}
										frameBorder="0"
										border="0"
										cellSpacing="0"
										style={{
											borderStyle:'none',
											width: "100%",
											height: "450px",
										}}/>
							}
							{(!this.state.url && this.state.loadingHtml) && <ReactLoadingTop style={{width: '90px', height: '90px'}}/>}
						</div>
						<div className="col-sm-2"/>
					</div>
				</div>
				{this.state.stockModal &&
					<ERPStockModalWs
						stock={this.state.stock}
						modal={this.state.stockModal}
						connectionInfo={this.state.connectionInfo}
						ws={this.state.ws}
						send={this.send}
						toggleModal={() => this.setState({stockModal:false})}
					/>
				}
			</DefaultModal>
		)
	}
}

export default ERPLineModalWs;
